var render = function render(){var _vm=this,_c=_vm._self._c;return _c('line-graph',{attrs:{"graph-data":_vm.graphData,"options":_vm.options,"name":"test-results"}})
}
var staticRenderFns = []

export { render, staticRenderFns }